'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgShare2 } from '@common/icon';
import { useState } from 'react';
import { Image } from '@/components/client';
import { FriendInviteShareDrawer } from '../../_components/FriendInviteShareDrawer';
import { INVITE_EVENT_CONFIG } from '../constants';
import { InviteCountdownTimer } from './InviteCountdownTimer';
export const InviteFooter = () => {
  const $ = _c(6);
  const [isShareDrawerOpen, setIsShareDrawerOpen] = useState(false);
  const handleShare = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <InviteCountdownTimer />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <button type="button" className="flex h-48 flex-1 items-center justify-center gap-8 rounded-small bg-[#ffde32]" onClick={() => setIsShareDrawerOpen(true)}><Image src="/assets/pngs/login/kakao.png" alt="" aria-hidden="true" width={24} height={24} /><span className="font-700 text-Gray-900 typo-body3">친구 초대하기</span></button>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="fixed inset-x-0 bottom-0 z-10 flex flex-col items-center bg-Gray-black/50 backdrop-blur-[10px]">{t0}<div className="flex w-full max-w-[750px] items-center gap-8 px-20 py-12">{t1}<Button theme="primary-text" className="p-0" onClick={handleShare} aria-label={"\uACF5\uC720\uD558\uAE30"}><SvgShare2 className="size-20 text-Gray-white" /></Button></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsShareDrawerOpen(false);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isShareDrawerOpen) {
    t4 = <>{t2}<FriendInviteShareDrawer opened={isShareDrawerOpen} onClose={t3} /></>;
    $[4] = isShareDrawerOpen;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
async function _temp() {
  if (!navigator.share) {
    return;
  }
  try {
    await navigator.share({
      title: INVITE_EVENT_CONFIG.share.title,
      text: INVITE_EVENT_CONFIG.share.description,
      url: window.location.href
    });
  } catch {}
}